<template>
    <CalendarHeadCell
        :class="cn('w-8 rounded-md text-sm font-normal leading-4 text-ds-gray-500', props.class)"
        v-bind="forwardedProps"
    >
        <slot />
    </CalendarHeadCell>
</template>

<script lang="ts" setup>
import { cn } from '@/lib/utils';
import { reactiveOmit } from '@vueuse/core';
import type { CalendarHeadCellProps } from 'reka-ui';
import { CalendarHeadCell, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<CalendarHeadCellProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>
